import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tooltips',
  templateUrl: './tooltips.component.html',
  styles: []
})
export class TooltipsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
